<template>
  <div>
    <a-upload :accept="accept" :multiple="limit > 1" :file-list="fileList" :before-upload="beforeFileUpload"
      :customRequest="handleFileUpload" :disabled="disabled || fileList.length >= limit" :showUploadList="false">
      <a-button class="spaceLeft" style="color: #1990ff">
        <svg class="icon img-icon" aria-hidden="true">
          <use xlink:href="#gold-icon-shangchuan"></use>
        </svg>上传文件
      </a-button>
    </a-upload>
    <div class="table-common common tableData" v-if="tableData.length > 0">
      <a-table :scroll="{ x: '100%', y: '170px' }" :loading="tableLoading" size="middle"
        :row-key="(record, index) => record.id + '_' + index" :columns="columns" :data-source="tableData"
        :pagination="false" bordered :locale="{ emptyText: '暂无数据' }">

        <template slot="fileNm" slot-scope="text,record">
          <a-button type="link" @click="handlePreview(record)">
            {{ text }}
          </a-button>
        </template>
        <template slot="createTime" slot-scope="text">
          {{ text | dateFormat("YYYY-mm-dd HH:MM:SS") }}
        </template>
        <template slot="status" slot-scope="text,record">
          <img v-if="record.status === 'done'" width="18" height="18"
            src="../../../assets/images/icon-img/file_done.png" />
          <img v-if="record.status === 'uploading'" width="18" height="18"
            src="../../../assets/images/icon-img/file_done.png" />
          <img v-if="record.status === 'wait' || record.status === ''" width="18" height="18"
            src="../../../assets/images/icon-img/file_done.png" />
          {{ getStatusRecod(record) }}
        </template>
        <template slot="oper" slot-scope="text, record, index">
          <a-button type="link" @click="handleSort(record, 'up')">上移</a-button>
          <a-button type="link" @click="handleSort(record, 'down')">下移</a-button>
          <span class="text-color-red pointer" @click="delFun(record, index)">删除</span>
          <!--          <a @click="downloadFile(record)">下载</a>-->
        </template>
      </a-table>
    </div>
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="预览图片" style="width: 100%" :src="previewImage" />
    </a-modal>
    <a-modal v-model="pdfVisible" title="PDF 预览" width="80%" :footer="null">
      <div ref="pdfContainer" style="height: 70vh; overflow: auto;"></div>
    </a-modal>
  </div>
</template>

<script>
import { fileDeletAPI, fileSaveAPI, fileQueryAPI } from "@/api/file.js";
import {
  updateFileSort
} from "@/api/payable.js";
export default {
  name: "fileUpload",
  props: {
    accept: {
      type: String,
      required: false,
      default: function () {
        return ".png,.PNG,.jpg,.JPG,.jpeg,.JPEG,.bmp,.pdf,.PDF,.zip,.ZIP,.rar,.RAR,.doc,.docx,.xls,.xlsx,.ppt,.pptx";
      },
    },
    url: {
      type: String,
      required: false,
      default() {
        return "/gb-bigtree-file/fileUpload";
      },
    },
    // 可传入接口需要的参数
    paramObj: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
    name: {
      type: String,
      required: true,
    },
    limit: {
      type: [String, Number],
      required: false,
      default: function () {
        return 1;
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      default: function () {
        return false;
      },
    },
    introducedSource: {
      type: [Array],
      default: function () {
        return null;
      }
    },
  },
  data() {
    return {
      pdfVisible: false,
      previewVisible: false,
      previewImage: null,
      fileList: [],
      paramObjSelf: this.utils.deepClone(this.paramObj),
      uploadFlag: true,
      tableLoading: false,
      tableData: [],
      columns: [
        {
          title: "文件名称",
          dataIndex: "fileNm",
          scopedSlots: { customRender: "fileNm" },
          width: "50%"
        },
        // {
        //   title: "上传人",
        //   dataIndex: "createUser"
        // },
        // {
        //   title: "上传日期",
        //   dataIndex: "createTime",
        //   scopedSlots: { customRender: "createTime" }
        // },
        {
          title: "上传结果",
          dataIndex: "status",
          scopedSlots: { customRender: "status" },
          width: "20%"
        },
        {
          title: "操作",
          dataIndex: "oper",
          scopedSlots: { customRender: "oper" },
          width: "30%"
        }
      ]
    };
  },
  watch: {
    introducedSource: {
      handler(val) {
        if (val && val.length > 0) {
          let length = val.length
          console.log("%c Line:151 🧀 val", "color:#2eafb0", val);
          this.tableData = val.map((it,index) => {
            return {...it,uid : it.id ,index,sort:length-index}
          });
        }
      },
      deep: true,
      immediate: true,
    },
    paramObjSelf: {
      handler(val) {
        console.log("%c Line:158 🥒 val", "color:#ffdd4d", val);
      },
      deep: true,
      immediate: true,
    }
  },

  created(){
    // if(this.introducedSource&&this.introducedSource.length>0){
    //   this.tableData = this.introducedSource;
    // }
  },
  methods: {
    initData() {
      this.tableData = [];
      this.paramObjSelf = this.utils.deepClone(this.paramObj)
      console.log("%c Line:181 🍻 this.paramObjSelf3333", "color:#2eafb0", this.paramObjSelf.tblBlId);
    },
    async lookFile(row) {
      console.log("%c Line:176 🍆 row", "color:#93c0a4", row);
      const pdfjsLib = await import('pdfjs-dist/build/pdf');
      const pdfjsWorker = await import('pdfjs-dist/build/pdf.worker.entry');

      pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
      console.log('%c Line:425 🍷 this.pdfUrl', 'color:#e41a6a', process.env);
      const pdfUrl = '/gb-bigtree-file/download/fileDownload/install' + row.fileRte + '/' + row.name;
      this.pdfVisible = true;

      // 加载 PDF
      const loadingTask = pdfjsLib.getDocument(pdfUrl);
      const pdf = await loadingTask.promise;

      // 渲染第一页
      const page = await pdf.getPage(1);
      const viewport = page.getViewport({ scale: 1.5 });
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      this.$refs.pdfContainer.innerHTML = '';
      this.$refs.pdfContainer.appendChild(canvas);

      await page.render({
        canvasContext: context,
        viewport
      }).promise;
    },
    handlePreview(data) {
      if(data.fileNm.includes('.ZIP') || data.fileNm.includes('.zip')){
        this.$message.warning('压缩包不支持预览')
        return;
      }
      if(data.fileNm.includes('.pdf') || data.fileNm.includes('.PDF')){
        this.lookFile(data);
      }else{
        this.previewImage = '/gb-bigtree-file/download/fileDownload/install' + data.fileRte + '/' + data.fileNm;;
      this.previewVisible = true;
      }
     
      
    },
     handleSort(data, text) {
      console.log('%c Line:114 🍓 data', 'color:#4fff4B', data);
      let sort = null;
      let sort1 = null;
      let uid = null;
      if (text == 'up') {
        if (this.tableData.length < 2) {
          return;
        }
        sort = Number(data.sort) + 1;
        console.log("%c Line:183 🍢 sort", "color:#ffdd4d", sort);
        if (sort > this.tableData.length) {
          return;
        }
        sort1 = data.sort;
        console.log("%c Line:187 🍯 sort1", "color:#ea7e5c", sort1);
        uid = this.tableData[data.index - 1].uid;
      } else {
        if (this.tableData.length < 2) {
          return;
        }
        sort = Number(data.sort) - 1;
        if (sort < 1) {
          return;
        }
        sort1 = data.sort;
        uid = this.tableData[data.index + 1].uid;
      }
      let params = [
        { uid: data.uid, sort: sort },
        { uid: uid, sort: sort1 }
      ];
      console.log(params);
      params.forEach((it) => {
        this.tableData.forEach((it1) => {
          if (it1.uid == it.uid) {
            it1.sort = it.sort;
          }
        });
      });
      this.tableData = this.tableData
        .sort((a, b) => Number(b.sort) - Number(a.sort))
        .map((it, index) => {
          return { ...it, index: index };
        });
        this.$emit("batchOpening", this.tableData);
      console.log("%c Line:216 🍷 this.tableData", "color:#b03734", this.tableData);

    },
    //排序
    updateSort(data) {
      updateFileSort({ list: data }).then(res => {
        //获取列表接口刷新
      })
    },
    beforeFileUpload(file) {
      
      const isLt4M = file.size / 1024 / 1024 <= 100
      if (!isLt4M) {
        this.$message.error('上传文件不能大于100M')
        return false
      }
      if (file.name && file.name.indexOf(".") > -1) {
        let d_name = file.name.substring(file.name.lastIndexOf(".") + 1);
        if (this.accept.indexOf(d_name) > -1) {
          if ((this.fileList.length + 1) > this.limit || (this.tableData.length + 1) > this.limit) {
            this.$message.warning(`选择文件不能超过${this.limit}个`)
            return false
          }
          let inItem = this.tableData.find(i => i.fileNm == file.name);
          if (inItem) {
            this.$message.warn("附件已在列表中，不可重复提交");
            return false;
          }
          let length = this.tableData.length;
          this.tableData = [{
            "fileNm": file.name,
            "uid": file.uid,
            "id": '',
            "fileId": '',
            "status": "wait",
            sort:length + 1 ,
            index:length ,
          },...this.tableData, ];
          this.tableData = this.tableData.map((it ,index)=> {
            return {...it,index}
          })
        } else {
          this.$message.error("请上传" + this.accept + "格式的文件");
          return false;
        }
      } else {
        this.$message.error("请上传" + this.accept + "格式的文件");
        return false;
      }
    },
    handleFileUpload(fileInfo) {
      console.log("%c Line:272 🍯 fileInfo", "color:#ea7e5c", fileInfo);
      this.tableData.forEach(item => {
        if (item.uid === fileInfo.file.uid) {
          item.status = 'uploading'
          return true
        }
      });

      const formData = new FormData();
      formData.append(this.name, fileInfo.file)
      for (let key in this.paramObjSelf) {
        formData.append(key, this.paramObjSelf[key])
      }

      this.axios({
        url: this.url,
        data: formData,
        isTransform: false,
      })
        .then((res) => {
        console.log("%c Line:292 🍪 res", "color:#7f2b82", res);

         })
        .catch((data) => {
          if (data[0]) {
            let fileData = {
              name: fileInfo.file.name,
              size: fileInfo.file.size,
              uid: fileInfo.file.uid,
              fileExpdNm: data[0].contentType,
              fileRte: JSON.parse(data[0].savePath).file,
              tblBlId: this.paramObjSelf.tblBlId,
              fileTpCd: this.paramObjSelf.fileTpCd,
              fileSubTpCd: this.paramObjSelf.fileSubTpCd,
              
            }
            this.tableData.forEach((item) => {
              if (item.uid === fileData.uid) {
                item.fileExpdNm= data[0].contentType
                item.fileRte= JSON.parse(data[0].savePath).file
                item.tblBlId= this.paramObjSelf.tblBlId
                item.fileTpCd= this.paramObjSelf.fileTpCd
                item.fileSubTpCd= this.paramObjSelf.fileSubTpCd
              }
            });
          

            
            this.fileSave(fileData)
          }
        });
    },
    fileSave(data) {
      const param = {
        fileNm: data.name,
        fileSize: data.size,
        fileRte: data.fileRte,
        fileExpdNm: data.fileExpdNm,
        tblBlId: data.tblBlId,
        mdlId: "10068",
        fileTpCd: "5",
        fileSubTpCd: 0
      };
      fileSaveAPI(param)
        .then(res => {
          console.log("%c Line:325 🌮 res", "color:#6ec1c2", res);
          this.$emit("uploadOk", data, this.paramObjSelf);
          let length = this.tableData.length;
          this.tableData.forEach((item,index) => {
            if (item.uid === data.uid) {
              item.status = 'done'
              item.id = res.data.id
              item.fileId = res.data.fileId
              item.tblBlId = res.data.tblBlId,
              item.index = index,
              item.sort =length - index

              return true
            }
          });
          this.$emit("batchOpening", this.tableData);
        })
        .catch(err => {
          console.log(err);
        });
    },
    delFun(record, index) {
      const self = this;
      this.$confirm({
        title: "删除",
        content: "您正在进行删除操作，是否确认？",
        onOk() {
          if (record.id === '') {
            self.tableData.splice(index, 1);
          } else {
           
               fileDeletAPI({
              id: record.id,
              // tblBlId: record.tblBlId,
              // fileId: record.fileId
            }).then(res => {
              self.$message.success("删除成功");
              self.tableData.splice(index, 1);
              self.$emit("batchOpening", self.tableData);
              // self.$emit("save");
            });
            
           
          }
        },
        onCancel() { }
      });
    },
    getStatusRecod(recod) {
      if (recod.status === 'done') {
        return '已完成'
      } else if (recod.status === 'uploading') {
        return '上传中'
      } else {
        return '待上传'
      }
    },
    downloadFile(item) {
      const DOWNLOAD_PREFIX = "/gb-bigtree-file/download/fileDownload/install";
      window.open(
        `${DOWNLOAD_PREFIX}${item.fileRte}/${item.fileNm || item.name}`,
        "_blank"
      );
    }
  },
  // watch: { 
  //   paramObj: {
  //     handler(val) {
  //       console.log("%c Line:365 🍪 val", "color:#7f2b82", val);
       
  //     },
  //     deep: true,
  //   },
  // },
};
</script>
<style scoped lang="less">
.ant-upload.ant-upload-disabled .ant-btn {
  cursor: no-drop;
  background: #f5f5f5;
}

.img-icon {
  font-size: 18px;
  cursor: pointer;
}

.tableData {
  position: relative;
  width: 700px;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/qxkl-file-upload/index.vue